import {
  actionTypes,
  AuthActions,
  CreateUserRequestAction,
  CreateUserFailAction,
  CreateUserSuccessAction,
  SaveCreateUserFormDataAction,
  CheckForExistingUserByMobileFailAction,
  CheckForExistingUserByMobileRequestAction,
  CheckForExistingUserByEmailFailAction,
  CheckForExistingUserByEmailRequestAction,
  CheckForExistingUserByEmailSuccessAction,
  CheckForExistingUserByMobileSuccessAction,
  ResetCreateUserStateAction,
  stateStatusType,
  UpdateCreateUserFormErrorAction,
  FetchUsersRequestAction,
  FetchUsersSuccessAction,
  FetchUsersFailureAction,
  ChangeUserPasswordRequestAction,
  ChangeUserPasswordSuccessAction,
  ChangeUserPasswordFailAction,
  ChangeUserNameFailAction,
  ChangeUserNameSuccessAction,
  ChangeUserNameRequestAction,
  ResetUserPasswordFailAction,
  ResetUserPasswordRequestAction,
  ResetUserPasswordSuccessAction,
  ChangeUserDeatilRequestAction,
  ChangeUserDeatilSuccessAction,
  ChangeUserDeatilFailAction,
  UpdateUserRolesSuccessAction,
  UpdateUserRolesFailAction,
  UpdateUserRolesRequestAction,
} from "./actionType";
import { updateObject } from "../../../../utils/helpers/updateObject";
import { initialState, UserStateProps } from "./state";

// fetchUsersRequest
const fetchUsersRequest = (
  state: UserStateProps,
  action: FetchUsersRequestAction
) => {
  return updateObject(state, {
    fetchUsersState: {
      ...state.fetchUsersState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchUsersSuccess = (
  state: UserStateProps,
  action: FetchUsersSuccessAction
) => {
  return updateObject(state, {
    fetchUsersState: {
      ...state.fetchUsersState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      users: action.payload,
    },
  });
};

const fetchUsersFail = (
  state: UserStateProps,
  action: FetchUsersFailureAction
) => {
  return updateObject(state, {
    fetchUsersState: {
      ...state.fetchUsersState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      users: null,
    },
  });
};

//Singup
const createUserRequest = (
  state: UserStateProps,
  action: CreateUserRequestAction
) => {
  return updateObject(state, {
    genericUserState: {
      ...state.genericUserState,
      isLoading: true,
      status: null,
      error: null,
    },
  });
};

const createUserSuccess = (
  state: UserStateProps,
  action: CreateUserSuccessAction
) => {
  const newUser = state.fetchUsersState.users ?? [];
  return updateObject(state, {
    genericUserState: {
      ...state.genericUserState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      error: null,
    },
    fetchUsersState: {
      ...state.fetchUsersState,
      users: [...newUser, action.payload], 
    }
  });
};

const createUserFail = (
  state: UserStateProps,
  action: CreateUserFailAction
) => {
  return updateObject(state, {
    genericUserState: {
      ...state.genericUserState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//Save Form Data
const saveCreateUserFormData = (
  state: UserStateProps,
  action: SaveCreateUserFormDataAction
) => {
  const now = new Date();
  return updateObject(state, {
    createUserFormData: {
      ...state.createUserFormData,
      ...action.payload,
      state_updated_at: String(now),
    },
  });
};

//Reset State
const resetCreateUserState = (
  state: UserStateProps,
  action: ResetCreateUserStateAction
) => {
  return updateObject(state, {
    ...initialState,
  });
};

//Reset State
const updateCreateUserFormErrorState = (
  state: UserStateProps,
  action: UpdateCreateUserFormErrorAction
) => {
  return updateObject(state, {
    signupFormError: {
      ...action.payload,
    },
  });
};

//CheckForExistingUserByMobile
const checkForExistingUserByMobileRequest = (
  state: UserStateProps,
  action: CheckForExistingUserByMobileRequestAction
) => {
  return updateObject(state, {
    checkForExistingUserByMobile: {
      ...state.checkForExistingUserByMobile,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByMobileSuccess = (
  state: UserStateProps,
  action: CheckForExistingUserByMobileSuccessAction
) => {
  return updateObject(state, {
    checkForExistingUserByMobile: {
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByMobileFail = (
  state: UserStateProps,
  action: CheckForExistingUserByMobileFailAction
) => {
  return updateObject(state, {
    checkForExistingUserByMobile: {
      ...state.checkForExistingUserByMobile,
      status: stateStatusType.FAILED,
      isLoading: false,
      error: action.payload,
    },
    createUserFormError: {
      ...state.createUserFormError,
      mobile_no: action.payload,
    },
  });
};

//CheckForExistingUserByMobile
const checkForExistingUserByEmailRequest = (
  state: UserStateProps,
  action: CheckForExistingUserByEmailRequestAction
) => {
  return updateObject(state, {
    checkForExistingUserByEmail: {
      ...state.checkForExistingUserByEmail,
      status: null,
      isLoading: true,
    },
  });
};
const checkForExistingUserByEmailSuccess = (
  state: UserStateProps,
  action: CheckForExistingUserByEmailSuccessAction
) => {
  return updateObject(state, {
    checkForExistingUserByEmail: {
      error: null,
      status: stateStatusType.SUCCESS,
      isLoading: false,
    },
  });
};

const checkForExistingUserByEmailFail = (
  state: UserStateProps,
  action: CheckForExistingUserByEmailFailAction
) => {
  return updateObject(state, {
    checkForExistingUserByEmail: {
      ...state.checkForExistingUserByEmail,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
    createUserFormError: {
      ...state.createUserFormError,
      email: action.payload,
    },
  });
};
// CHNAGE PASSWORD
const changePasswordRequest = (state: UserStateProps, action: ChangeUserPasswordRequestAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null
        }
    });
};

const changePasswordSuccess = (state: UserStateProps, action: ChangeUserPasswordSuccessAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            state: stateStatusType.SUCCESS,
            error: null
        }
    });
};

const changePasswordFail = (state: UserStateProps, action: ChangeUserPasswordFailAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            state: stateStatusType.FAILED,
            error: action.payload
        }
    });
};
// RESET PASSWORD
const resetPasswordRequest = (state: UserStateProps, action: ResetUserPasswordRequestAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null
        }
    });
};

const resetPasswordSuccess = (state: UserStateProps, action: ResetUserPasswordSuccessAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            state: stateStatusType.SUCCESS,
            error: null
        }
    });
};

const resetPasswordFail = (state: UserStateProps, action: ResetUserPasswordFailAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            state: stateStatusType.FAILED,
            error: action.payload
        }
    });
};

//update User name
const changeUserNameRequest = (state: UserStateProps, action: ChangeUserNameRequestAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null,
            status: null
        }
    });
};

const changeUserNameSuccess = (state: UserStateProps, action: ChangeUserNameSuccessAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null,
            status: stateStatusType.SUCCESS
        },
        fetchUsersState: {
            ...state.fetchUsersState,
            users: {
                ...action.payload
            }
        }
    });
};

const changeUserNameFail = (state: UserStateProps, action: ChangeUserNameFailAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: action.payload,
            status: stateStatusType.FAILED
        }
    });
};
//update User detail
const changeUserDetailRequest = (state: UserStateProps, action: ChangeUserDeatilRequestAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null,
            status: null
        }
    });
};

const changeUserDetailSuccess = (state: UserStateProps, action: ChangeUserDeatilSuccessAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null,
            status: stateStatusType.SUCCESS
        },
        fetchUsersState: {
            ...state.fetchUsersState,
            users: {
                ...action.payload
            }
        }
    });
};

const changeUserDetailFail = (state: UserStateProps, action: ChangeUserDeatilFailAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: action.payload,
            status: stateStatusType.FAILED
        }
    });
};

//update user roles
const updateUserRolesRequest = (state: UserStateProps, action: UpdateUserRolesRequestAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: null,
            status: null
        }
    });
};

const updateUserRolesSuccess = (state: UserStateProps, action: UpdateUserRolesSuccessAction) => {
  const updatedUser = action.payload; // this is the updated single user
  
  return updateObject(state, {
    genericUserState: {
      ...state.genericUserState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchUsersState: {
      ...state.fetchUsersState,
      users: state.fetchUsersState?.users?.map((user) =>
        user.id === updatedUser.id ? { ...user, ...updatedUser } : user
      ),
    },
  });
};


const updateUserRolesFail = (state: UserStateProps, action: UpdateUserRolesFailAction) => {
    return updateObject(state, {
        genericUserState: {
            ...state.genericUserState,
            isLoading: false,
            error: action.payload,
            status: stateStatusType.FAILED
        }
    });
};

//Auth Reducers
const UserReducer = (state = initialState, action: AuthActions) => {
  switch (action.type) {
    case actionTypes.FETCH_USERS_REQUEST:
      return fetchUsersRequest(state, action);
    case actionTypes.FETCH_USERS_SUCCESS:
      return fetchUsersSuccess(state, action);
    case actionTypes.FETCH_USERS_FAIL:
      return fetchUsersFail(state, action);
    case actionTypes.CREATE_USER_REQUEST:
      return createUserRequest(state, action);
    case actionTypes.CREATE_USER_SUCCESS:
      return createUserSuccess(state, action);
    case actionTypes.CREATE_USER_FAIL:
      return createUserFail(state, action);
    case actionTypes.SAVE_CREATE_USER_FORM_DATA:
      return saveCreateUserFormData(state, action);
    case actionTypes.RESET_CREATE_USER_STATE:
      return resetCreateUserState(state, action);
    case actionTypes.UPDATE_CREATE_USER_FORM_ERROR:
      return updateCreateUserFormErrorState(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_REQUEST:
      return checkForExistingUserByMobileRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_SUCCESS:
      return checkForExistingUserByMobileSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_FAIL:
      return checkForExistingUserByMobileFail(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_REQUEST:
      return checkForExistingUserByEmailRequest(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_SUCCESS:
      return checkForExistingUserByEmailSuccess(state, action);
    case actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_FAIL:
      return checkForExistingUserByEmailFail(state, action);
    case actionTypes.CHANGE_USER_NAME_REQUEST:
      return changeUserNameRequest(state, action)
    case actionTypes.CHANGE_USER_NAME_SUCCESS:
      return changeUserNameSuccess(state, action)
    case actionTypes.CHANGE_USER_NAME_FAIL:
      return changeUserNameFail(state, action)
    case actionTypes.CHANGE_USER_PASSWORD_REQUEST:
      return changePasswordRequest(state, action)
    case actionTypes.CHANGE_USER_PASSWORD_SUCCESS:
      return changePasswordSuccess(state, action)
    case actionTypes.CHANGE_USER_PASSWORD_FAIL:
      return changePasswordFail(state, action)
    case actionTypes.RESET_USER_PASSWORD_REQUEST:
      return resetPasswordRequest(state, action)
    case actionTypes.RESET_USER_PASSWORD_SUCCESS:
      return resetPasswordSuccess(state, action)
    case actionTypes.RESET_USER_PASSWORD_FAIL:
      return resetPasswordFail(state, action)
    case actionTypes.CHANGE_USER_DETAIL_REQUEST:
      return changeUserDetailRequest(state, action)
    case actionTypes.CHANGE_USER_DETAIL_SUCCESS:
      return changeUserDetailSuccess(state, action)
    case actionTypes.CHANGE_USER_DETAIL_FAIL:
      return changeUserDetailFail(state, action)
    case actionTypes.UPDATE_USER_ROLES_REQUEST:
      return updateUserRolesRequest(state, action)
    case actionTypes.UPDATE_USER_ROLES_SUCCESS:
      return updateUserRolesSuccess(state, action)
    case actionTypes.UPDATE_USER_ROLES_FAIL:
      return updateUserRolesFail(state, action)
    default:
      return state;
  }
};

export default UserReducer;
